import {
  setShowSystemKeys,
} from '../../facts/table-view';

require('./chat-viewer.component.scss');

class ChatViewerController {
  constructor(
    $scope,
    $window,
    $element,
    $timeout,
    RouterService,
    CurrentModelService,
    CurrentFilterService,
    ErrorHandlerService,
    AggregateDataService,
    LayoutService,
  ) {
    this.router = RouterService;
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterService = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.AggregateDataService = AggregateDataService;
    this.typeDim = 'agent_eventtype@default:agent_eventtype';
    this.$element = $element;
    this.previousTop = -1;
    this.dialogBody = this.$element.context.querySelector('.dialog-body');
    this.filterData = this.router.CurrentFilterDataService.filterData;
    this._data = [];
    this._isSuitFilter = true;
    this.needToScroll = false;
    this.headData = {
      canChange: true,
      membersDim: 'agent_dialog@members:members',
      channelDim: 'agent_dialog@dialog_type:dialog_type',
      length: 0,
    };
    this.doOnScroll = true;

    this.$scope.$on('factsLoaded', () => {
      if (!this.filterData.filterData || !this.filterData.filterData) return;
      this.chatData = this.filterData.filterData;
      if (this.previousTop === -1) this.previousTop = this.dialogBody.scrollTop;
      this.resortData();
      this.scrollToFCurrectFact(true);
      this.isMore = false;
    });

    this.$timeout(() => this.resortData(), 10);
    setShowSystemKeys(LayoutService.options);
  }

  get chatData() {
    return this._data;
  }

  set chatData(data) {
    if (this.isMore) this._data = this._data.concat(data);
    else this._data = data;
  }

  resortData() {
    if (!this.chatData) return;
    const fVal = fact => {
      const date = new Date(fact['local_time']);
      return {
        id: +fact['id'],
        t: date.valueOf() + date.getTimezoneOffset() * 60000,
        u: fact['agent_account.user_name'] ? fact['agent_account.user_name'].toLowerCase() : '',
        m: fact['agent_dialog.members'] ? fact['agent_dialog.members'].toLowerCase() : '',
      };
    };

    this._data = this.chatData.sort((aFact, bFact) => {
      const a = fVal(aFact);
      const b = fVal(bFact);
      if (a.m === b.m) {
        if (a.t === b.t) {
          if (a.u === b.u) return a.id - b.id;
          return a.u > b.u ? 1 : -1;
        } else return a.t - b.t;
      } else {
        return a.m > b.m ? 1 : -1;
      }
    });
    this.setDialogHead(this.headData.fact ? this.headData.fact : this._data[0], true);
    this.needToScroll = true;
  }

  scrollToFCurrectFact(isLast) {
    if (this.CurrentFilterService.filter &&
      this.CurrentFilterService.filter.isCardOrDashboard) return true;
    if (!isLast || !this.needToScroll) return true;
    this.needToScroll = false;
    this.$timeout(() => {
      if (!this.chatData) return true;
      this.$element.find('.dialog-body').scrollTop(0);
      this.$timeout(() => {
        if (!this.headData.user) this.onScroll();
        this.headData.canChange = true;
      }, 200);
    }, 200);
    return true;
  }

  getCurrentFact() {
    return this.chatData.find(f => f.needToShowTD);
  }

  setFilterCut(dim, val) {
    this.curFilter.cleanFilter(dim);
    this.curFilter.addFilter(dim, val, val);
    this.router.filterChanged();
  }

  hasAccounts(accountKey) {
    return this.headData.fact.accounts && this.headData.fact.accounts[accountKey];
  }

  setDialogHead(fact, forse = false) {
    if (!fact) return;
    if (!this.headData.canChange && !forse) return;
    this.headData.fact = fact;
    this.headData.id = fact.id;

    this.headData.members = fact['agent_dialog.members'];
    if (!this.headData.members) this.headData.members = gettext('Значение не указано');
    this.headData.membersArr = this.headData.members ? Array.from(new Set(this.headData.members.split(' '))) : [];
    this.headData.fact = fact;
    this.headData.channel = fact['agent_dialog.dialog_type'];
    if (!this.headData.channel) this.headData.channel = gettext('Значение не указано');
    this.headData.length = this.chatData ? this.chatData.length : this.filterData.filterData.length;
  }

  onScroll(e) {
    if (!this.doOnScroll) return;
    this.doOnScroll = false;
    this.$timeout(() => {
      this.setDialogHead(this.getCurrentFact());
      // if (this.headData.canChange && this.previousTop < this.dialogBody.scrollTop &&
      //   (this.dialogBody.scrollHeight - this.dialogBody.scrollTop - this.dialogBody.clientHeight) / this.dialogBody.scrollHeight * 100 < 5) {
      //   this.more();
      // }
      // this.previousTop = this.dialogBody.scrollTop;
      this.doOnScroll = true;
    }, 200);

  }

  showHead(i) {
    const headData = fact => ({
      channel: fact['agent_dialog.dialog_type'],
      members: fact['agent_dialog.members'],
    });
    if (i === 0) return true;
    return !angular.equals(headData(this.chatData[i - 1]), headData(this.chatData[i]));
  }

  get isLoading() {
    const loading = this.CurrentModelService.loading ||
      this.filterData.loading ||
      this.filterData.loadingMore ||
      this.AggregateDataService.loading ||
      this.AggregateDataService.loadingMore;
    return loading;
  }

  more(e) {
    this.isMore = true;
    if (this.isLoading) return null;
    return this.filterData.moreFacts();
  }

  nextPage() {
    if (this.isLoading || !this.hasMorePages) return null;
    this.filterData.initPage += 1;
    return this.filterData.update(this.filter);
  }

  prevPage() {
    if (this.isLoading || !this.filterData.initPage) return null;
    this.filterData.initPage -= 1;
    return this.filterData.update(this.filter);
  }

  openImage(fact) {
    const url = 'media/' + fact['agent_attachedfile.data'];
    // console.log( url);
    this.$window.open(url);
  }

  get curFilter() {
    if (this.router.isFilterEditModal) return this.filter;
    return this.filter ? this.filter : this.CurrentFilterService.filter;
  }

  get participants() {
    const dim = this.curFilter.filters.find(f => f.dimension === this.threadDim);
    return dim ? dim.label : '';
  }

  get hasMorePages() {
    return this.headData.length == this.filter.limit;
  }

  get firstFact() {
    if (!this.chatData || !this.chatData.length) return {
      userId: 0,
      userName: '',
      channel: '',
    };
    const f1 = this.chatData[0];
    return {
      userId: f1['agent_account.id'],
      userName: f1['agent_account.user_name'],
      channel: f1['agent_dialog.dialog_type']
    };
  }

  get isErrorChatFilter() {
    return this.ErrorHandlerService.filterErrorMessage.text;
  }
}


export const ChatViewerComponent = {
  template: require('./chat-viewer.component.html'),
  bindings: {
    model: '<',
    filter: '<',
    filterData: '<',
  },
  controller: ChatViewerController,
};



// WEBPACK FOOTER //
// ./src/view/chat-viewer/chat-viewer.component.js